import { render, staticRenderFns } from "./NewsflashAdmin.vue?vue&type=template&id=76d7ee98&scoped=true&"
import script from "./NewsflashAdmin.vue?vue&type=script&lang=js&"
export * from "./NewsflashAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NewsflashAdmin.vue?vue&type=style&index=0&id=76d7ee98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d7ee98",
  null
  
)

export default component.exports